// src/utils/permissionsClient.js

const ADMIN_KEYWORDS = ['admin', 'administrator'];

const normalize = (value) =>
    typeof value === 'string' ? value.trim().toLowerCase() : null;

const matchesAdminKeyword = (value) => {
    const normalized = normalize(value);
    return normalized ? ADMIN_KEYWORDS.includes(normalized) : false;
};

const isTruthyAdminValue = (value) => {
    if (value === true) return true;
    if (typeof value === 'string') {
        const normalized = normalize(value);
        return normalized === 'true' || matchesAdminKeyword(normalized);
    }
    return false;
};

const collectionContainsAdmin = (values) =>
    Array.isArray(values) &&
    values.some((value) => matchesAdminKeyword(value) || isTruthyAdminValue(value));

export function hasAdminPrivileges(user) {
    if (!user) return false;

    if (isTruthyAdminValue(user.isAdmin)) return true;
    if (isTruthyAdminValue(user.admin)) return true;

    if (matchesAdminKeyword(user.role)) return true;
    if (matchesAdminKeyword(user.accountType)) return true;
    if (matchesAdminKeyword(user.account_type)) return true;

    if (collectionContainsAdmin(user.roles)) return true;
    if (collectionContainsAdmin(user.tags)) return true;
    if (collectionContainsAdmin(user.permissions)) return true;

    return false;
}

function toPlainObject(entity) {
    if (!entity) return entity;
    if (typeof entity.toObject === 'function') {
        return entity.toObject({ virtuals: true });
    }
    if (typeof entity.toJSON === 'function') {
        return entity.toJSON({ virtuals: true });
    }
    return { ...entity };
}

export function addEffectiveAdminFlag(user) {
    if (!user) return user;
    const plainUser = toPlainObject(user);
    plainUser.isAdmin = hasAdminPrivileges(plainUser);
    return plainUser;
}

export function addEffectiveAdminFlagToArray(users) {
    if (!Array.isArray(users)) return users;
    return users.map((user) => addEffectiveAdminFlag(user));
}

const permissionsClient = {
    hasAdminPrivileges,
    addEffectiveAdminFlag,
    addEffectiveAdminFlagToArray,
};

export default permissionsClient;
